import { PageHeader } from '@celltrak/ui-components';

const SetupHeader = () => (
  <header>
    <PageHeader title="Setup" />
  </header>
);

export default SetupHeader;
